{
  "close": "إغلاق",
  "notifications": "إشعارات"
}
